import React from 'react';
import PropTypes from 'prop-types';
import styles from '../ArticleComponents.module.css';

export default class InfogramComponent extends React.Component {
	componentDidMount() {
		this.onLoad();
	}

	onLoad = () => {
		// eslint-disable-next-line no-unused-expressions
		!(function (e, i, n) {
			var t = 'InfogramEmbeds',
				d = e.getElementsByTagName('script')[0];
			if (window[t] && window[t].initialized)
				window[t].process && window[t].process();
			else if (!e.getElementById(n)) {
				var o = e.createElement('script');
				// eslint-disable-next-line no-unused-expressions
				(o.async = 1),
					(o.id = n),
					(o.src =
						'https://e.infogram.com/js/dist/embed-loader-min.js'),
					d.parentNode.insertBefore(o, d);
			}
			console.log(`Infogram loaded`);
		})(document, 0, 'infogram-async');
	};
	render() {
		const { component, readerMode } = this.props;
		if (readerMode) {
			return null;
		}
		const { dataid } = component;
		return (
			<div className={styles['component-infogram']}>
				<div
					className="infogram-embed"
					data-id={dataid}
					data-type="interactive"
				/>
			</div>
		);
	}
}

InfogramComponent.propTypes = {
	component: PropTypes.object.isRequired,
	readerMode: PropTypes.bool,
};